import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Features from "../components/Features";
import EmotionCards from "../components/EmotionCards";
import Testimonials from "../components/Testimonials";
import Pricing from "../components/Pricing";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function Landing() {
  const landingSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "FeelTalk",
    url: "https://feeltalk.live",
    description: "FeelTalk connects you with compassionate, verified listeners 24/7 for safe, anonymous, and confidential emotional support.",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://feeltalk.live/select-emotion?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Someone to Talk To, Anytime"
        description="Connect with compassionate, verified listeners 24/7. Safe, anonymous, and confidential emotional support whenever you need it."
        schema={landingSchema}
      />
      <Navbar />
      <main id="main-content">
        <Hero />
        <Features />
        <EmotionCards />
        <Testimonials />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
}
